
// This file is auto generated from package.json
const c = {
  "name": "TruexRefApp_IMA_CSAI",
  "version": "1.0.0",
  "buildDate": "2021-10-25 23:54:48",
  "buildEnv": "dev"
};

export const config = c;
export default config;
